import { useState } from "react";
import styled from "styled-components";
import { removeOnClickBubble } from "utils";
import { Popover } from "antd";
// import Cross from "../../../assets/img/icons/cross_grey.svg";
import Search from "../../../assets/img/icons/ArticlePopover/lowerList/search.svg";
import List from "../../../assets/img/icons/ArticlePopover/lowerList/list.svg";
// import Frame from "../../../assets/img/icons/ArticlePopover/lowerList/frame.svg";
import Profile from "../../../assets/img/icons/ArticlePopover/lowerList/profile.svg";
import Delete from "../../../assets/img/icons/ArticlePopover/lowerList/Delete.svg";
// import Send from "../../../assets/img/icons/Send (5).svg";
import Edit from "../../../assets/img/icons/Edit.svg";
import EditGrey from "../../../assets/img/icons/EditGrey.svg";
import COPY from "../../../assets/img/icons/copy.svg";
import CLONE_COPY from "../../../assets/img/icons/clone_copy.svg";

import { useHistory } from "react-router";
import CreateAsset from "modules/Campaigns/CampaignAssets/Components/CreateAsset";
// import { removeEmailFromEmailBrowserList } from "modules/EmailBrowser/actions";
// import CreateCampaign from "modules/Campaigns/CampaignAssets/Components/CreateCampaign";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import { DESIGN } from "constants/actionTypes";
import { getQueryCampaignId } from "modules/EmailBrowser/utils";
import InfoPopover from "./InfoPopover";

const PopupTitle = ({
  campaignId,
  id,
  emailType,
  cloneDraftEmailToCurrentCampaign,
  hide,
  emailName,
  isWfAction,
}: any) => {
  const history = useHistory();

  const cloningInProgress = useSelector((state: RootState) => state.emails.cloningInProgress);

  const onEditEmail = (e: any) => {
    removeOnClickBubble(e);
    // if (isWfAction) return;
    store.dispatch({
      type: DESIGN.RESET,
    });
    if (emailType > 0) history.push(`/campaigns/editionedit/design/?campaign_id=${campaignId}&email_id=${id}`);
    else history.push(`/campaigns/editionedit/?campaign_id=${campaignId}&email_id=${id}`);
  };
  const onCloneEmail = (e: any) => {
    removeOnClickBubble(e);
    cloneDraftEmailToCurrentCampaign(hide);
  };
  const onCloneEmailToExistingOrNewCampaign = (e: any) => {
    removeOnClickBubble(e);
  };
  // const history = useHistory();
  const popoverText = "Emails added to the workflows cannot be edited";
  return (
    <BlogMenuStylingGreen>
      <div onClick={(e) => removeOnClickBubble(e)} className="BlogItemDropdown">
        <ul>
          <li
            className={`d-flex align-items-center justify-content-between  ${isWfAction ? "wf-action-email" : ""}`}
            onClick={onEditEmail}
          >
            <span className={`align-items-center`}>
              <img className="margin-right-sm" src={Edit} alt="edit" />
              <strong>Edit Draft</strong>
            </span>
            {/* {isWfAction && <InfoPopover infoText={popoverText} width={250} height={70} />} */}
          </li>
          <li
            className={`d-flex align-items-center ${cloningInProgress ? "disabled" : ""}`}
            onClick={onCloneEmail}
          >
            <img className="margin-right-sm" src={CLONE_COPY} alt="clone" />
            <strong>Clone Draft</strong>
            &nbsp;
            <div hidden={!cloningInProgress} className="spinner-border spinner-border-sm" role="status">
              <span className="sr-only"></span>
            </div>
          </li>
          <li className="d-flex align-items-center" onClick={onCloneEmailToExistingOrNewCampaign}>
            <img className="margin-right-sm" src={COPY} alt="" />
            <CreateAsset
              hideDynamic={true}
              noDropdown={true}
              cloneDraftEmailToCampaign={true}
              emailName={emailName}
              draftEmailId={id}
              hide={hide}
              campaignId={getQueryCampaignId()}
            >
              <strong>Copy and Save to Campaign</strong>
            </CreateAsset>
          </li>
        </ul>
      </div>
    </BlogMenuStylingGreen>
  );
};

// const Content = ({
//   id,
//   data,
//   isFav,
//   isCurated,
//   campaignId,
//   index,
//   deleteHandler,
//   assetId,
//   assetIndex,
//   assetDeleteHandler,
//   assetCount,
//   hide,
//   emailType,
// }: any) => {
//   const history = useHistory();
//   const onSmartSourceClick = (e: any) => {
//     removeOnClickBubble(e);
//     history.push(`/campaigns/content/asset/source?campaign_id=${campaignId}&asset_id=${assetId}`);
//   };
//   const onContactsClick = (e: any) => {
//     removeOnClickBubble(e);
//     history.push(`/campaigns/content/asset/audience?campaign_id=${campaignId}&asset_id=${assetId}`);
//   };
//   const onDraftsClick = (e: any) => {
//     removeOnClickBubble(e);
//     history.push(`/campaigns/content/asset?campaign_id=${campaignId}&asset_id=${assetId}`);
//   };
//   const onSentClick = (e: any) => {
//     removeOnClickBubble(e);
//     history.push(`/campaigns/content/asset/sent?campaign_id=${campaignId}&asset_id=${assetId}`);
//   };

//   return (
//     <BlogMenuStyling>
//       <div className="BlogItemDropdown">
//         <ul>
//           {emailType == "0" && (
//             <li className="d-flex align-items-center" onClick={onSmartSourceClick}>
//               <img className="margin-right-sm" src={Search} alt="icon" />
//               <strong> View SmartSourced Content</strong>
//             </li>
//           )}
//           {emailType == "0" && (
//             <li className="d-flex align-items-center" onClick={onContactsClick}>
//               <img className="margin-right-sm" src={Profile} alt="icon" />
//               <strong> Contacts who'd be interested</strong>
//             </li>
//           )}

//           <li className="d-flex align-items-center" onClick={onContactsClick}>
//             <img className="margin-right-sm" src={List} alt="icon" />
//             <strong> View recipents and lists</strong>
//           </li>
//           <li
//             onClick={(e) => {
//               hide();
//               removeOnClickBubble(e);
//               if (assetDeleteHandler) {
//                 assetDeleteHandler(assetIndex, assetId);
//               } else {
//                 deleteHandler(index, campaignId, assetCount);
//               }
//             }}
//             className="d-flex align-items-center"
//           >
//             <img className="margin-right-sm" src={Delete} alt="icon" />
//             <strong> Delete Asset</strong>
//           </li>
//         </ul>
//       </div>
//     </BlogMenuStyling>
//   );
// };

const EmailContent = ({
  id,
  data,
  isFav,
  isCurated,
  campaignId,
  index,
  deleteHandler,
  assetId,
  assetIndex,
  assetDeleteHandler,
  assetCount,
  hide,
  emailType,
  workflowAutomation,
}: any) => {
  return (
    <BlogMenuStyling>
      <div onClick={(e) => removeOnClickBubble(e)} className="BlogItemDropdown">
        <ul>
          <li
            onClick={(e) => {
              hide();
              if (assetDeleteHandler) {
                assetDeleteHandler(assetIndex, assetId);
              }
            }}
            className={`d-flex align-items-center`}
          >
            <img className="margin-right-sm" src={Delete} alt="icon" />
            <strong>Delete Draft</strong>
          </li>
        </ul>
      </div>
    </BlogMenuStyling>
  );
};

const AssetMenuPopup = (props: any) => {
  const [visible, setVisible] = useState(false);
  const {
    id,
    data,
    isFav,
    isCurated,
    campaignId,
    index,
    deleteHandler,
    assetId,
    assetIndex,
    assetDeleteHandler,
    assetCount,
    emailType,
    cloneDraftEmailToCurrentCampaign,
    emailName,
    workflowAutomation,
    isWfActionEmail,
  } = props;

  const isOverlay = useSelector((state: RootState) => state.uiReducer.overlay);

  const hide = () => {
    setVisible(false);
  };

  const handleVisibleChange = (visible: any) => {
    setVisible(visible);
  };

  return (
    <Popover
      overlayInnerStyle={{ borderRadius: 10 }}
      overlayClassName={`BlogPopover popover-radius Popover-share overflow-fix ${isOverlay ? "top-20000" : ""} ${workflowAutomation ? "workflow-automation" : ""
        }`}
      placement="leftTop"
      visible={visible}
      // title={popupTitle(data)}
      title={
        <PopupTitle
          campaignId={props.campaignId}
          id={id}
          emailType={emailType}
          cloneDraftEmailToCurrentCampaign={cloneDraftEmailToCurrentCampaign}
          hide={hide}
          emailName={emailName}
          isWfAction={isWfActionEmail}
        />
      }
      getPopupContainer={() => document.querySelectorAll(".content-inner")[0] as HTMLElement}
      content={
        <EmailContent
          id={id}
          data={data}
          isFav={isFav}
          isCurated={isCurated}
          campaignId={campaignId}
          index={index}
          deleteHandler={deleteHandler}
          assetId={assetId}
          assetIndex={assetIndex}
          assetDeleteHandler={assetDeleteHandler}
          assetCount={assetCount}
          hide={hide}
          emailType={emailType}
          workflowAutomation={workflowAutomation}
        />
      }
      destroyTooltipOnHide={true}
      trigger="click"
      onVisibleChange={handleVisibleChange}
    >
      <div
        onClick={(e: any) => {
          removeOnClickBubble(e);
        }}
      >
        {props.children}
      </div>
    </Popover>
  );
};

const BlogMenuStylingGreen = styled.div`
  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  ul li {
    font-family: "roboto_regular", sans-serif;
    font-size: 14px;
    color: #27ce0a;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .opc-5 {
    opacity: 0.5;
  }
`;
const BlogMenuStyling = styled.div`
  ul li {
    font-family: "roboto_regular", sans-serif;
    font-size: 14px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
`;

export default AssetMenuPopup;
